import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { LoadingBarService } from "@ngx-loading-bar/core";

import Swal from "sweetalert2";

import {
  HeaderService,
  ServicesService,
  FiltersService
} from "../../../shared";

@Component({
  selector: "app-services-edit",
  templateUrl: "./services-edit.component.html",
  styleUrls: ["./services-edit.component.scss"]
})
export class ServicesEditComponent implements OnInit {
  title = "EDIÇÃO DE SERVIÇO";
  subtitle = "Utilize os campos abaixo para editar o serviço";
  urlBack = "/panel/services/list";

  editService = new FormGroup({
    cdFornecedor: new FormControl(""),
    lojas: new FormControl(""),
    cdArea: new FormControl(""),
    cdProduto: new FormControl(""),
    vlMaxManutencao: new FormControl(0),
    vlMaxMaterial: new FormControl(0),
    cdsImpostoSap: new FormControl(""),
    dsComplementoSap: new FormControl(""),
    dsOperacaoSap: new FormControl(""),
    dsProjetoSap: new FormControl(""),
    flNovaLoja: new FormControl(0)
  });

  id;

  selectedStores = [];

  providersArr;

  relatedEquipments = [
    {
      cdArea: "",
      cdProduto: "",
      vlMaxManutencao: 0,
      vlMaxMaterial: 0
    }
  ];

  constructor(
    private headerService: HeaderService,
    private filtersService: FiltersService,
    private servicesService: ServicesService,
    private activatedRoute: ActivatedRoute,
    private loadingBarService: LoadingBarService,
    private router: Router
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Edição de serviço");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.filtersService.listProviders().subscribe(response => {
      this.providersArr = response["data"];
    });

    this.loadingBarService.start();

    this.servicesService.getService(this.id).subscribe(response => {
      this.editService.patchValue({
        cdFornecedor: response["data"].cdFornecedor,
        lojas: response["data"].lojas,
        cdArea: response["data"].cdArea,
        cdProduto: response["data"].cdProduto,
        vlMaxManutencao: response["data"].vlMaxManutencao,
        vlMaxMaterial: response["data"].vlMaxMaterial,
        cdsImpostoSap: response["data"].cdsImpostoSap,
        dsComplementoSap: response["data"].dsComplementoSap,
        dsOperacaoSap: response["data"].dsOperacaoSap,
        dsProjetoSap: response["data"].dsProjetoSap
      });

      this.selectedStores = response["data"].lojas;

      this.relatedEquipments = [
        {
          cdArea: response["data"].cdArea,
          cdProduto: response["data"].cdProduto,
          vlMaxManutencao: response["data"].vlMaxManutencao,
          vlMaxMaterial: response["data"].vlMaxMaterial
        }
      ];

      this.loadingBarService.complete();
    });
  }

  storesValues(arr) {
    this.editService.patchValue({
      lojas: arr
    });

    this.selectedStores = arr;
  }

  limiteCaractere(evento, limite) {
    const limit = +limite;
    if (evento.target.value.length == limit) evento.preventDefault();
  }

  equipmentsValues(arr) {
    this.editService.patchValue({
      cdArea: arr[0].cdArea,
      cdProduto: arr[0].cdProduto,
      vlMaxManutencao: arr[0].vlMaxManutencao,
      vlMaxMaterial: arr[0].vlMaxMaterial
    });

    this.relatedEquipments = arr;
  }

  updateService() {
    this.loadingBarService.start();

    this.servicesService
      .editService(this.editService.value)
      .subscribe(response => {
        this.loadingBarService.complete();

        Swal({
          type: "success",
          title: "Serviço editado",
          text: "O serviço será exibido na listagem",
          confirmButtonText: "Ok, entendi!",
          confirmButtonClass: "sweet-button",
          buttonsStyling: false
        }).then(result => {
          this.router.navigate([this.urlBack]);
        });
      });
  }

  deleteService() {
    this.loadingBarService.start();

    this.servicesService
      .deleteService(this.editService.value)
      .subscribe(response => {
        this.loadingBarService.complete();

        Swal({
          type: "success",
          title: "Serviço excluído",
          text: "O serviço foi removido do cadastro",
          confirmButtonText: "Ok, entendi!",
          confirmButtonClass: "sweet-button",
          buttonsStyling: false
        }).then(result => {
          this.router.navigate([this.urlBack]);
        });
      });
  }
}
